import { Loader2 } from 'lucide-react';

const SimpleFallback = () => {
  return (
    <div className="fixed inset-0 z-[100] flex h-screen w-screen items-center justify-center overflow-hidden bg-slate-50 transition-colors duration-300 dark:bg-gray-900">
      <Loader2
        className="text-primary-100 h-12 w-12 animate-spin dark:text-orange-500"
        strokeWidth={2.5}
      />
    </div>
  );
};

export default SimpleFallback;
